var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-view withoutNav pb0"},[_c('div',{staticClass:"layout-view hg50"},[_c('CumulativeActivityNumber')],1),_c('div',{staticClass:"layout-view hg50"},[_c('CumulativeActivityElderNumber')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }